export const localStorageUserKey = "user";

declare global {
    interface Window {
        __RUNTIME_CONFIG__?: {
            BASE_URL?: string;
        };
    }
}

const runtimeBaseUrl = window.__RUNTIME_CONFIG__?.BASE_URL;

export const baseUrl =
    runtimeBaseUrl && runtimeBaseUrl !== "__BASE_URL__"
        ? runtimeBaseUrl
        : "http://localhost:8080";

export const uiVersion = process.env.REACT_APP_VERSION || "unknown";

export const headers: { 
    Authorization?: string 
    SuppressLoading?: boolean;
} = {};

export const dropDownPageSize = 12;